// @flow

import type { PropsSchema, BasicProps } from '../../type'
import type { Visitor } from 'projects/easy/public/type'
import * as React from 'react'
import computeData from '../hoc/computeData'

import Picker from 'antd-mobile/lib/picker';
import 'antd-mobile/dist/antd-mobile.css';


type Props = BasicProps & {
  style: { [string]: string },
  field: string,
  visitor: Visitor,
  query: { [string]: string },
  placeholder: string,
  popupTitle: string,
  extra:string,
  cols: number,
  setFormValues: ({ [key: string]: any }) => void,
  formValues: { [string]: string },
  match:string,
      initData:any,
};

const CustomChildren = ({ extra , onClick, style }) => (
  <div
    onClick={onClick}
    style={{...style}}
  >
    <span>{extra}</span>
  </div>
);
@computeData()
export default class FormChooseInput extends React.PureComponent<Props, {}> {
  static defaultProps = {
    type: 'text'
  };

  constructor (props: Props) {
    super(props)
  }

  static schema: PropsSchema = [
  {
    title: '初始化数据',
    key: 'initData',
    type: 'code'
  },
    {
      key: 'field',
      title: '字段',
      type: 'text'
    },
    {
      key: 'popupTitle',
      title: '弹窗标题',
      type: 'text'
    },
    {
      key: 'cols',
      title: '列数',
      type: 'text'
    },
    {
      key: 'extra',
      title: '占位内容',
      type: 'text'
    },
    {
      key: 'match',
      title: '选择后的分隔符',
      type: 'text'
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: '取消',
      event: 'cancel'
    },
    {
      type: 'event',
      title: '选择完成',
      event: 'completeF'
    }
  ];
  onChangeFn=(value:any) =>{
    let { field, setFormValues,callActions } = this.props
    setFormValues({ [field]: value })
    callActions('completeF',value)
  }

  getFieldValue = (props?: Props): string => {
    const { field, formValues } = props || this.props
    return formValues[field] == null ? '' : formValues[field]
  };
  onDismiss(){
    const { callActions } = this.props
    callActions('completeF')
  }

  componentDidMount () {
  }
  formatFn(labels: any){
    const {match}=this.props;
    return labels.join(`${match||' '}`);
  }
  render () {
    if (!this.props.visible) {
      return null
    }

    let {style,popupTitle,extra,cols} = this.props;
    let {jsEnv,initData } = this.props
    initData = jsEnv.runCode(initData)
    return (
      <div>
      <Picker
          data={initData}
          title={popupTitle}
          cascade={true}
          extra={extra}
          cols={cols||2}
          value={this.getFieldValue()}
          onOk={this.onChangeFn}
          format={this.formatFn.bind(this)}
          onDismiss={this.onDismiss.bind(this)}
        >
          <CustomChildren style={style} extra='' onClick={()=>{}}></CustomChildren>
        </Picker>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/FormChooseInput.js